<template>
  <div
    class="table-header position-relative"
    :class="{ active: field.sortable }"
  >
    <span class="mr-1">
      {{ field.name }}
    </span>
    <font-awesome-icon
      v-if="isSorting(field, 'asc')"
      :icon="faSortUp"
      class="icon position-absolute asc h-100"
    />
    <font-awesome-icon
      v-if="isSorting(field, 'desc')"
      :icon="faSortDown"
      class="icon position-absolute desc h-100"
    />
  </div>
</template>

<script>
import { faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    sortBy: {
      type: String,
      required: false
    },
    sortDirection: {
      type: String,
      required: false
    }
  },
  data: () => ({
    faSortUp,
    faSortDown
  }),
  methods: {
    isSorting(field, direction) {
      return this.sortBy === field.field && this.sortDirection === direction
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@vars";

.table-header {
  &.active {
    cursor: pointer;
  }

  > .icon {
    top: 6px;
    color: $gray-800;

    &.desc {
      top: 1px;
    }
  }
}
</style>
